import { useSelector } from '../../_shared/utils/hooks/useSelector';
import { type AppState } from '../app.store';

export const isCurrentMapSnapshot = (state: AppState): boolean =>
  !!state.map.mapInfo.data?.parentMap;

export const useIsCurrentMapSnapshotSelector = () => useSelector(isCurrentMapSnapshot);
